/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teen_Setting_LabelInputs */

const fr_teen_setting_label = /** @type {(inputs: Teen_Setting_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cours adultes par mois`)
};

/**

* @param {Teen_Setting_LabelInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const teen_setting_label = /** @type {((inputs?: Teen_Setting_LabelInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teen_Setting_LabelInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_teen_setting_label(inputs)
});